(function () {
  "use strict";

  if (window.__LV_CART_AFFILIATE_RECONCILER__) return;
  window.__LV_CART_AFFILIATE_RECONCILER__ = true;

  var NS = "[LV CART RECON]";
  var DEBUG = true;

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, [NS].concat([].slice.call(arguments))); } catch (_) {}
  }

  function warn() {
    try { console.warn.apply(console, [NS].concat([].slice.call(arguments))); } catch (_) {}
  }

  function normalizeId(v) {
    return v == null ? "" : String(v).trim();
  }

  function toHandle(v) {
    return String(v || "").toLowerCase().trim();
  }

  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function getAffiliateSession() {
    try {
      if (window.__lvGetAffiliateSession) {
        return window.__lvGetAffiliateSession() || null;
      }
      var raw = sessionStorage.getItem("affiliate.session");
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function getAffiliateSessionCode() {
    try {
      var sess = getAffiliateSession();
      if (!sess) return "";
      return normalizeId(
        sess.discountCode ||
        sess.discount_code ||
        sess.code ||
        ""
      );
    } catch (e) {
      return "";
    }
  }

  function isAffiliateCartMode() {
    return !!getAffiliateSessionCode();
  }

  function getDesiredCartMode() {
    return isAffiliateCartMode() ? "affiliate" : "standard";
  }

  function getDesiredDirection() {
    return isAffiliateCartMode() ? "to_affiliate" : "to_standard";
  }
 
// WORKING DRAFT
function getAffiliateSessionFamily() {
    try {
        var sess = getAffiliateSession();
        if (!sess) return "";
        return String(
        sess.planFamily ||
        sess.plan_family ||
        sess.umbrella ||
        sess.networkPricingFamily ||
        ""
        ).toLowerCase().trim();
    } catch (e) {
        return "";
    }
}

function inferFamilyFromPlanId(planId) {
    var id = normalizeId(planId);
    if (!id) return "";

    try {
        var families = window.__LV_AFFILIATE_PLAN_FAMILIES__ || {};
        var keys = Object.keys(families);

        for (var i = 0; i < keys.length; i++) {
        var familyKey = keys[i];
        var cfg = families[familyKey];
        if (!cfg) continue;

        var groupToStandard = cfg.groupToStandard || {};
        var standardToAffiliate = cfg.standardToAffiliate || {};
        var affiliateToStandard = cfg.affiliateToStandard || {};

        // 1) Current plan is itself a standard plan in this family
        var standardIds = Object.keys(groupToStandard).map(function (groupId) {
            return normalizeId(groupToStandard[groupId]);
        });

        if (standardIds.indexOf(id) !== -1) {
            return toHandle(familyKey);
        }

        // 2) Current plan is an affiliate plan in this family
        var affiliateIds = Object.keys(affiliateToStandard).map(function (affiliateId) {
            return normalizeId(affiliateId);
        });

        if (affiliateIds.indexOf(id) !== -1) {
            return toHandle(familyKey);
        }

        // 3) Current plan appears as a mapped affiliate target in this family
        var mappedAffiliateIds = Object.keys(standardToAffiliate).map(function (standardId) {
            return normalizeId(standardToAffiliate[standardId]);
        });

        if (mappedAffiliateIds.indexOf(id) !== -1) {
            return toHandle(familyKey);
        }
        }
    } catch (e) {}

    return "";
}

function getPlanConfig(handle) {
    var h = toHandle(handle);
    if (!h) return null;

    try {
        if (window.__lvIsAffiliatePlanAllowedHandle) {
        if (!window.__lvIsAffiliatePlanAllowedHandle(h)) return null;
        }
    } catch (_) {}

    try {
        var family = getAffiliateSessionFamily();
        var families = window.__LV_AFFILIATE_PLAN_FAMILIES__ || {};

        // 1) Preferred: active affiliate session family
        if (family && families[family]) {
        return families[family];
        }

        // 2) Fallback: global resolver (may work when session exists or if handle maps)
        if (window.__lvGetAffiliatePlanConfig) {
        var cfg = window.__lvGetAffiliatePlanConfig(h);
        if (cfg) return cfg;
        }

        // 3) Unaffiliated fallback:
        // if this product is allowlisted and there is only one family configured,
        // use that family so standard-mode cart UI can still prune correctly.
        var keys = Object.keys(families);
        if (keys.length > 1) {
            return families[keys[0]] || null;
        }
    } catch (_) {}

    return null;
}

  function isAllowedHandle(handle) {
    try {
      if (window.__lvIsAffiliatePlanAllowedHandle) {
        return !!window.__lvIsAffiliatePlanAllowedHandle(handle);
      }
    } catch (e) {}
    return !!getPlanConfig(handle);
  }

  function mapPlanIdForHandle(planId, direction, handle) {
    var cfg = getPlanConfig(handle, planId);
    if (!cfg || !planId) return normalizeId(planId);

    var id = normalizeId(planId);

    if (direction === "to_standard") {
      return normalizeId(
        (cfg.affiliateToStandard && cfg.affiliateToStandard[id]) || id
      );
    }

    return normalizeId(
      (cfg.standardToAffiliate && cfg.standardToAffiliate[id]) || id
    );
  }

  function getPlanIdForGroupHandle(groupId, mode, handle, currentPlanId) {
    var cfg = getPlanConfig(handle, currentPlanId);
    if (!cfg || !groupId) return null;

    var base = cfg.groupToStandard && cfg.groupToStandard[normalizeId(groupId)];
    if (!base) return null;

    if (mode === "affiliate") {
      return normalizeId(
        (cfg.standardToAffiliate && cfg.standardToAffiliate[normalizeId(base)]) || base
      );
    }

    return normalizeId(base);
  }

  function getCartDisplayPlansForHandle(handle, currentPlanId) {
    var cfg = getPlanConfig(handle, currentPlanId);
    if (!cfg) return null;

    var mode = getDesiredCartMode();
    var oneMonthPlanId = cfg.oneMonthGroupId
      ? getPlanIdForGroupHandle(cfg.oneMonthGroupId, mode, handle)
      : null;
    var threeMonthPlanId = cfg.threeMonthGroupId
      ? getPlanIdForGroupHandle(cfg.threeMonthGroupId, mode, handle)
      : null;

    return {
      mode: mode,
      handle: toHandle(handle),
      oneTime: null,
      oneMonth: {
        groupId: normalizeId(cfg.oneMonthGroupId || ""),
        sellingPlanId: normalizeId(oneMonthPlanId || "")
      },
      threeMonth: {
        groupId: normalizeId(cfg.threeMonthGroupId || ""),
        sellingPlanId: normalizeId(threeMonthPlanId || "")
      },
      allowedSellingPlanIds: [oneMonthPlanId, threeMonthPlanId]
        .filter(Boolean)
        .map(normalizeId)
    };
  }

  // Expose this for the cart UI layer
  window.__lvGetCartDisplayPlansForHandle = getCartDisplayPlansForHandle;

  // Also expose a direct helper for cart plan toggles
  window.__lvGetCartTargetSellingPlanForGroup = function (handle, groupId) {
    return getPlanIdForGroupHandle(groupId, getDesiredCartMode(), handle);
  };

  async function getCartSnapshot() {
    var res = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store",
        headers: { "Accept": "application/json" }
    });

    if (!res.ok) throw new Error("cart.js fetch failed");
    return await res.json();
  }

  function getCurrentSellingPlanId(item) {
    if (!item) return "";

    var fromAlloc =
      item.selling_plan_allocation &&
      item.selling_plan_allocation.selling_plan &&
      item.selling_plan_allocation.selling_plan.id;

    var fromDirect = item.selling_plan;

    return normalizeId(fromAlloc || fromDirect || "");
  }

  function isSubscriptionLine(item) {
    return !!getCurrentSellingPlanId(item);
  }

  function isEligibleAffiliateLine(item) {
    if (!item) return false;
    if (!isSubscriptionLine(item)) return false;

    var handle = toHandle(item.handle);
    if (!handle) return false;
    if (!isAllowedHandle(handle)) return false;
    if (!getPlanConfig(handle)) return false;

    return true;
  }

  function buildReplacementItem(item, desiredPlanId) {
    var next = {
      id: Number(item.variant_id || item.id),
      quantity: Math.max(1, Number(item.quantity || 1))
    };

    if (desiredPlanId) {
      next.selling_plan = normalizeId(desiredPlanId);
    }

    if (item.properties && typeof item.properties === "object") {
      next.properties = Object.assign({}, item.properties);
    }

    return next;
  }

  async function addItemsBatch(items) {
    if (!items || !items.length) return { items: [] };

    if (window.cartAdd) {
      return window.cartAdd({ items: items });
    }

    var res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: items })
    });

    if (!res.ok) {
      throw new Error("add.js failed");
    }

    return await res.json();
  }

  async function removeLineByKey(lineKey) {
    var res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        id: normalizeId(lineKey),
        quantity: 0
      })
    });

    if (!res.ok) {
      throw new Error("change.js remove failed");
    }

    return await res.json();
  }

  function refreshDrawerBurst() {
    try { window.upcartRefreshCart && window.upcartRefreshCart(); } catch (_) {}

    ["upcart:refresh", "cart:refresh", "cart:updated"].forEach(function (evt) {
      try {
        document.dispatchEvent(new CustomEvent(evt));
      } catch (_) {}
    });

    setTimeout(function () {
      try { window.upcartRefreshCart && window.upcartRefreshCart(); } catch (_) {}
    }, 150);
  }

  // function findReconcilableLines(cart) {
  //   var direction = getDesiredDirection();
  //   var items = Array.isArray(cart && cart.items) ? cart.items : [];
  //   var out = [];

  //   items.forEach(function (item) {
  //     if (!isEligibleAffiliateLine(item)) return;

  //     var handle = toHandle(item.handle);
  //     var currentPlanId = getCurrentSellingPlanId(item);
  //     if (!currentPlanId) return;

  //     var desiredPlanId = mapPlanIdForHandle(currentPlanId, direction, handle);
  //     desiredPlanId = normalizeId(desiredPlanId);

  //     if (!desiredPlanId || desiredPlanId === currentPlanId) return;

  //     out.push({
  //       item: item,
  //       handle: handle,
  //       currentPlanId: currentPlanId,
  //       desiredPlanId: desiredPlanId
  //     });
  //   });

  //   return out;
  // }
    function findReconcilableLines(cart) {
    var direction = getDesiredDirection();

    // GUARD: never downgrade a clinic plan to standard. "No affiliate session"
    // (new browser session, recovery not finished) is not evidence the shopper
    // isn't a clinic patient. Upgrades (to_affiliate) are unchanged.
    if (direction === "to_standard") {
      var wouldDowngrade = (Array.isArray(cart && cart.items) ? cart.items : []).filter(function (it) {
        var id = getCurrentSellingPlanId(it);
        return id && mapPlanIdForHandle(id, "to_standard", toHandle(it.handle)) !== id;
      }).length;
      if (wouldDowngrade) {
        log("blocked downgrade to standard", { lines: wouldDowngrade });
        try {
          window.posthog && window.posthog.capture("cart recon downgrade blocked", { lines: wouldDowngrade });
        } catch (_) {}
      }
      return [];
    }

    var items = Array.isArray(cart && cart.items) ? cart.items : [];
    var out = [];

    items.forEach(function (item) {
      if (!isEligibleAffiliateLine(item)) return;

      var handle = toHandle(item.handle);
      var currentPlanId = getCurrentSellingPlanId(item);
      if (!currentPlanId) return;

      var desiredPlanId = mapPlanIdForHandle(currentPlanId, direction, handle);
      desiredPlanId = normalizeId(desiredPlanId);

      if (!desiredPlanId || desiredPlanId === currentPlanId) return;

      out.push({
        item: item,
        handle: handle,
        currentPlanId: currentPlanId,
        desiredPlanId: desiredPlanId
      });
    });

    return out;
  }

  async function replaceLineWithMappedPlan(entry) {
    var item = entry.item;
    var desiredPlanId = entry.desiredPlanId;

    var replacement = buildReplacementItem(item, desiredPlanId);

    log("replacing line", {
      handle: item.handle,
      key: item.key,
      quantity: item.quantity,
      currentPlanId: entry.currentPlanId,
      desiredPlanId: desiredPlanId
    });

    await addItemsBatch([replacement]);
    await removeLineByKey(item.key);
  }

  var reconcileLock = false;
  var reconcileTimer = null;

  async function reconcileAffiliateCart(reason) {
    if (reconcileLock) {
      log("skip reconcile: already running", reason);
      return;
    }

    reconcileLock = true;

    try {
      var cart = await getCartSnapshot();
      var targets = findReconcilableLines(cart);

      if (!targets.length) {
        log("no cart mismatches", reason, { mode: getDesiredCartMode() });
        return;
      }

      log("reconciling cart", reason, {
        mode: getDesiredCartMode(),
        count: targets.length
      });

      // Add/remove sequentially to reduce race conditions in drawer apps
      for (var i = 0; i < targets.length; i++) {
        await replaceLineWithMappedPlan(targets[i]);
        await sleep(60);
      }

      refreshDrawerBurst();

      try {
        window.__lvScheduleUpcartPlanEnforceBurst &&
            window.__lvScheduleUpcartPlanEnforceBurst("post_reconcile_refresh");
    } catch (_) {}

      try {
        window.dispatchEvent(new CustomEvent("lv:cart_reconciled", {
          detail: {
            reason: reason || "",
            mode: getDesiredCartMode(),
            count: targets.length
          }
        }));
      } catch (_) {}
    } catch (e) {
      warn("reconcile failed", reason, e);
    } finally {
      reconcileLock = false;
    }
  }

  function scheduleAffiliateCartReconcile(reason, delay) {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileAffiliateCart(reason);
    }, Number(delay || 120));
  }

  window.__lvReconcileAffiliateCart = reconcileAffiliateCart;
  window.__lvScheduleAffiliateCartReconcile = scheduleAffiliateCartReconcile;

  // Wrap affiliate mode changes so cart always follows session truth
  if (typeof window.__lvActivateAffiliatePricing === "function" && !window.__lvActivateAffiliatePricing.__lvWrappedForCartRecon) {
    var origActivate = window.__lvActivateAffiliatePricing;
    var wrappedActivate = function () {
      var out = origActivate.apply(this, arguments);
      scheduleAffiliateCartReconcile("affiliate_activate", 120);
      return out;
    };
    wrappedActivate.__lvWrappedForCartRecon = true;
    window.__lvActivateAffiliatePricing = wrappedActivate;
  }

  if (typeof window.__lvDeactivateAffiliatePricing === "function" && !window.__lvDeactivateAffiliatePricing.__lvWrappedForCartRecon) {
    var origDeactivate = window.__lvDeactivateAffiliatePricing;
    var wrappedDeactivate = function () {
      var out = origDeactivate.apply(this, arguments);
      scheduleAffiliateCartReconcile("affiliate_deactivate", 120);
      return out;
    };
    wrappedDeactivate.__lvWrappedForCartRecon = true;
    window.__lvDeactivateAffiliatePricing = wrappedDeactivate;
  }

  // Existing event path compatibility
  window.addEventListener("lv:affiliate_pricing_activated", function () {
    scheduleAffiliateCartReconcile("affiliate_event_activated", 120);
  });

  window.addEventListener("lv:affiliate_pricing_deactivated", function () {
    scheduleAffiliateCartReconcile("affiliate_event_deactivated", 120);
  });

  // Upcart lifecycle hooks
  window.addEventListener("upcart:opened", function () {
    scheduleAffiliateCartReconcile("upcart_opened", 120);
  }, { passive: true });

  window.addEventListener("upcart:cart:updated", function () {
    scheduleAffiliateCartReconcile("upcart_updated", 180);
  }, { passive: true });

  try {
    if (typeof window.upcartOnCartOpened === "function") {
      window.upcartOnCartOpened(function () {
        scheduleAffiliateCartReconcile("upcartOnCartOpened", 120);
      });
    }
  } catch (_) {}

  try {
    if (typeof window.upcartOnCartUpdated === "function") {
      window.upcartOnCartUpdated(function () {
        scheduleAffiliateCartReconcile("upcartOnCartUpdated", 180);
      });
    }
  } catch (_) {}

  try {
    if (typeof window.upcartSubscribeCartOpened === "function") {
      window.upcartSubscribeCartOpened(function () {
        scheduleAffiliateCartReconcile("upcartSubscribeCartOpened", 120);
      });
    }
  } catch (_) {}

  try {
    if (typeof window.upcartSubscribeCartUpdated === "function") {
      window.upcartSubscribeCartUpdated(function () {
        scheduleAffiliateCartReconcile("upcartSubscribeCartUpdated", 180);
      });
    }
  } catch (_) {}

  // Safety net after add-to-cart submits anywhere
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = normalizeId(form.getAttribute("action") || "").toLowerCase();
    if (action.indexOf("/cart/add") !== -1) {
      scheduleAffiliateCartReconcile("submit_add_to_cart", 350);
    }
  }, true);

  // Boot once after page settles
  setTimeout(function () {
    scheduleAffiliateCartReconcile("boot", 250);
  }, 0);

  // setTimeout(function () {
  //   try {
  //       var h =
  //           (window.__lvGetCurrentProductHandle && window.__lvGetCurrentProductHandle()) ||
  //           (window.meta && window.meta.product && window.meta.product.handle) ||
  //           "";

  //       if (!h) return;

  //       var changed = normalizeStandardPlansOnLoad(h);

  //       if (changed && window.__lvRefreshLoopWidgetOnly) {
  //           setTimeout(function () {
  //               window.__lvRefreshLoopWidgetOnly();
  //           }, 80);
  //       }
  //   } catch (_) {}
  // }, 300);
})();